import React from 'react';
import ConversationalAIComponent from '../components/ConversationalAI/ConversationalAIComponent';

function ConversationalAIPage() {
  return <ConversationalAIComponent />;
}

export default ConversationalAIPage;
